import React, { lazy, Suspense } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const HeadingsPanelController = lazy(
  () => import('wix-rich-content-toolbars-modals').then(({ HeadingsPanelController: HeadingsPanelController2 }) => ({
    default: HeadingsPanelController2
  }))
);
const HeadingPanelComponent = (suspenseWidth) => (props) => /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", { style: { width: suspenseWidth } }) }, /* @__PURE__ */ React.createElement(HeadingsPanelController, __spreadValues({}, props)));

export { HeadingPanelComponent as default };
//# sourceMappingURL=HeadingsPanelComponent.js.map
